__turbopack_context__.v({
  "buttonWrapper": "CardColumnContent-module-scss-module__Yy9z9W__buttonWrapper",
  "columnContent": "CardColumnContent-module-scss-module__Yy9z9W__columnContent",
  "columnContentInner": "CardColumnContent-module-scss-module__Yy9z9W__columnContentInner",
  "creamBackground": "CardColumnContent-module-scss-module__Yy9z9W__creamBackground",
  "cta2": "CardColumnContent-module-scss-module__Yy9z9W__cta2",
  "ctaDuo": "CardColumnContent-module-scss-module__Yy9z9W__ctaDuo",
  "eyebrowWrapper": "CardColumnContent-module-scss-module__Yy9z9W__eyebrowWrapper",
  "image": "CardColumnContent-module-scss-module__Yy9z9W__image",
  "imgWrapper": "CardColumnContent-module-scss-module__Yy9z9W__imgWrapper",
  "textWrapper": "CardColumnContent-module-scss-module__Yy9z9W__textWrapper",
});
